import { render, staticRenderFns } from "./ProfileBannerImage.vue?vue&type=template&id=1343e25c"
import script from "./ProfileBannerImage.vue?vue&type=script&lang=js"
export * from "./ProfileBannerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports